import { Button } from "@chakra-ui/react";
import { PlusMath } from "@airhelp/icons";

interface AddConnectionButtonProps {
  onClick: () => void;
}

export const AddConnectionButton = ({ onClick }: AddConnectionButtonProps) => (
  <Button ml={2} justifySelf="flex-start" size="xl" variant="subtle" leftIcon={<PlusMath />} onClick={onClick} />
);
